export const isBase64Image = (url?: string): boolean => {
    return url ? url.includes('data:image') : false;
};